import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { EProduct } from "@rentiohq/shared-frontend/dist/config/app.config.types";
import logger from "@rentiohq/shared-frontend/dist/logger";
import consoleLogger from "@rentiohq/shared-frontend/dist/logger/loggers/logger.console";
import sentryLogger from "@rentiohq/shared-frontend/dist/logger/loggers/logger.sentry";
import {
  getLocale,
  getLocalizedText,
  setLocale,
} from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { setStore } from "@rentiohq/shared-frontend/dist/utils/redux/redux.utils";
import { Loading } from "@rentiohq/web-shared/dist/components";
import { defaultTheme } from "@rentiohq/web-theme";
import * as Sentry from "@sentry/browser";
import { createBrowserHistory } from "history";
import * as ReactDOM from "react-dom";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.minimal.css";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import "./index.css";
import store from "./redux/store";
import { AppRouter } from "./routes/router";
import * as serviceWorker from "./serviceWorker";

// Dirty fix to prevent console warnings in development
// This silences incorrect prop passing that are used in styled components
if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line no-console
  console.warn = (original => {
    return (...args) => {
      if (
        typeof args[0] === "string" &&
        args[0].includes("styled-components: it looks like an unknown prop")
      ) {
        return;
      }

      original(...args);
    };
    // eslint-disable-next-line no-console
  })(console.warn);

  // eslint-disable-next-line no-console
  console.error = (original => {
    return (...args) => {
      const silenceOptions = [
        "Warning: React does not recognize the",
        "Warning: Each child in a list should have a unique",
        "for a non-boolean attribute",
        "cannot appear as a descendant of",
      ];

      if (
        typeof args[0] === "string" &&
        silenceOptions.some(option => args[0].includes(option))
      ) {
        return;
      }
      original(...args);
    };
    // eslint-disable-next-line no-console
  })(console.error);
}

setLocale(navigator.language);
setStore(store);

// @ts-ignore
window.zESettings = {
  webWidget: {
    color: {
      theme: defaultTheme.colors.primary[800],
      launcherText: defaultTheme.colors.neutral0,
    },
    chat: {
      suppress: false,
    },
    helpCenter: {
      suppress: false,
    },
    contactForm: {
      suppress: false,
      attachments: true,
    },
  },
};

setTimeout(() => {
  // @ts-ignore
  window.zE?.("webWidget", "setLocale", getLocale());

  // @ts-ignore
  window.zE?.("webWidget", "hide");
}, 100);

const SENTRY_FEEDBACK_KEYS = {
  title: getLocalizedText("sentry.feedback_modal.title"),
  subtitle: getLocalizedText("sentry.feedback_modal.subtitle"),
  subtitle2: getLocalizedText("sentry.feedback_modal.subtitle_2"),
  labelName: getLocalizedText("sentry.feedback_modal.label_name"),
  labelEmail: getLocalizedText("sentry.feedback_modal.label_email"),
  labelComments: getLocalizedText("sentry.feedback_modal.label_comments"),
  labelSubmit: getLocalizedText("sentry.feedback_modal.label_submit"),
  labelClose: getLocalizedText("sentry.feedback_modal.label_close"),
  errorFormEntry: getLocalizedText("sentry.feedback_modal.error_form_entry"),
  errorGeneric: getLocalizedText("sentry.feedback_modal.error_generic"),
  successMessage: getLocalizedText("sentry.feedback_modal.success_message"),
};

export const history = createBrowserHistory();

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: CONFIG.SENTRY[EProduct.Dashboard],
    environment: CONFIG.ENVIRONMENT,
    release: CONFIG.SENTRY_RELEASE,
    beforeSend(event) {
      if (event.extra?.fatal === "true") {
        Sentry.showReportDialog({
          // TODO: Prefill user name & email
          // user: {
          //   name: "demo",
          //   email: "dries@rentio.be",
          // },
          ...SENTRY_FEEDBACK_KEYS,
          eventId: event.event_id,
        });
      }
      return event;
    },
  });
  logger.registerLogger(sentryLogger);

  // eslint-disable-next-line no-console
  console.log("Sentry release version: ", CONFIG.SENTRY_RELEASE);
}

if (process.env.NODE_ENV === "development") {
  logger.registerLogger(consoleLogger);
}

// @ts-ignore
window.pageDate = new Date();

ReactDOM.render(
  <BrowserRouter>
    <ReduxProvider store={store}>
      <PersistGate
        // @ts-ignore
        persistor={persistStore(store)}
        loading={<Loading />}
      >
        <AppRouter />
      </PersistGate>
    </ReduxProvider>
  </BrowserRouter>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
